module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre1",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "id": "toc"
    }
  }), _vm._v("CONTENTS.")]), _vm._v(" "), _c('p', {
    staticClass: "nind"
  }, [_c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0003#PREFACE"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Preface.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n  ———"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0004#INTRODUCTION"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Introduction.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n  ———"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0005#QUOTATIONS"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Quotations.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n  ———"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0006#Daniel_Drew"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Daniel Drew.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0007#Russell_Sage"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Russell Sage.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0008#Cornelius_Vanderbilt"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Cornelius Vanderbilt.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0009#Amos_Lawrence"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Amos Lawrence.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0010#Horace_B_Claflin"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Horace B. Claflin.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0011#William_E_Dodge"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("William E. Dodge.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0012#Jay_Gould"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Jay Gould.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0013#John_Wannamaker"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John Wannamaker.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0014#Alexander_T_Stewart"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Alexander T. Stewart.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0015#Nicholas_Longworth"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Nicholas Longworth.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0016#Robert_Bonner"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Robert Bonner.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0017#William_G_Fargo"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("William G. Fargo.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0018#James_C_Flood"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James C. Flood.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0019#John_W_MacKay"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John W. MacKay.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0020#James_C_Fair"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James C. Fair.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0021#Horace_Greeley"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Horace Greeley.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('a', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0022#Thurlow_Weed"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Thurlow Weed.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0023#George_W_Childs",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George W. Childs.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0025#James_Gordon_Bennett",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James Gordon Bennett.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0026#Phineas_T_Barnum",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Phineas T. Barnum.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0027#Mathew_Vassar",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mathew Vassar.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0028#John_Jacob_Astor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John Jacob Astor.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0029#Potter_Palmer",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Potter Palmer.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0030#James_Harper",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James Harper.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0031#Henry_Disston",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Henry Disston.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0032#Peter_Cooper",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Peter Cooper")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0032#George_Law",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George Law.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0033#Darius_O_Mills",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Darius O. Mills.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0034#Stephen_Girard",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Stephen Girard.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0035#Moses_Taylor",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Moses Taylor.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0036#William_C_Ralston",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("William C. Ralston.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0037#George_Peabody",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George Peabody.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0038#William_W_Corcoran",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("William W. Corcoran.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0039#Nathan_Mayer_Rothschild",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Nathan Mayer Rothschild.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0039#John_Adams",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John Adams.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0041#Thomas_Jefferson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Thomas Jefferson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0042#John_Marshall",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John Marshall.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0043#Alexander_Hamilton",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Alexander Hamilton.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0044#James_Madison",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James Madison.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0045#James_Monroe",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James Monroe.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0047#Lewis_Cass",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lewis Cass.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0048#John_C_Calhoun",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John C. Calhoun.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0049#Robert_Y_Hayne",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Robert Y. Hayne.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0050#Daniel_Webster",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Daniel Webster.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0051#Andrew_Jackson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Andrew Jackson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0052#Thomas_H_Benton",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Thomas H. Benton.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0053#Henry_Clay",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Henry Clay.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0054#Martin_Van_Buren",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Martin Van Buren.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0055#Stephen_Arnold_Douglass",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Stephen Arnold Douglass.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0056#Abbott_Lawrence",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Abbott Lawrence.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0057#Alexander_H_Stephens",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Alexander H. Stephens.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0058#Millard_Fillmore",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Millard Fillmore.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0059#William_H_Seward",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("William H. Seward.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0060#Horatio_Seymour",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Horatio Seymour.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0061#Winfield_S_Hancock",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Winfield S. Hancock.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0062#George_B_McClellan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George B. McClellan.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0063#Ulysses_Simpson_Grant",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ulysses Simpson Grant.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0064#Stonewall_Jackson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Stonewall Jackson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0065#General_Robert_E_Lee",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("General Robert E. Lee.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0066#Henry_Wilson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Henry Wilson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0067#Abraham_Lincoln",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Abraham Lincoln.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0068#Edward_Everett",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Edward Everett.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0069#Edwin_M_Stanton",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Edwin M. Stanton.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0070#Andrew_Johnson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Andrew Johnson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0071#James_A_Garfield",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James A. Garfield.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0072#Chester_A_Arthur",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Chester A. Arthur.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0073#John_A_Logan",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("John A. Logan.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0075#James_G_Blaine",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James G. Blaine.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0077#Samuel_J_Tilden",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Samuel J. Tilden.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0078#Henry_Ward_Beecher",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Henry Ward Beecher.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0078#James_Watt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("James Watt.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0079#George_Stephenson",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George Stephenson.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0080#Benjamin_Franklin",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Benjamin Franklin.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0081#Eli_Whitney",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Eli Whitney.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0082#Robert_Fulton",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Robert Fulton.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0083#Elias_Howe_Jr",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Elias Howe, Jr.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0084#Isaac_M_Singer",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Isaac M. Singer.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0085#Richard_M_Hoe",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Richard M. Hoe.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0086#Charles_Goodyear",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Charles Goodyear.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0087#Prof_S_F_B_Morse",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Prof. S. F. B. Morse.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0088#Cyrus_W_Field",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Cyrus W. Field.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0090#George_M_Pullman",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George M. Pullman.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0091#Thomas_A_Edison",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Thomas A. Edison.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Why Some Succeed And While Others Fail.")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0091#SUCCESS_AND_FAILURE",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Success And Failure.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0092#Concentration_of_Effort",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Concentration of Effort.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0093#Self-reliance",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Self-reliance.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0094#Economy_of_Time",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Economy of Time.")])]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', {
    staticClass: "calibre3 pcalibre1 pcalibre2 pcalibre",
    attrs: {
      "href": "#/Text/Section0095#Causes_of_Failure",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Causes of Failure.")])]), _c('br', {
    staticClass: "calibre2"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0